import { profileReportApi } from "../../api";

const ProfileReportService = {
  /**
   * 🔹 Obtener todos los reportes (habilitados y no habilitados) de un perfil
   * @param profileId ID del perfil de cliente
   */
  getReportsByProfile: async (profileId: number) => {
    const response = await profileReportApi.fetchCustom(`/${profileId}`);
    return response.data;
  },

  /**
   * 🔹 Obtener todos los reportes globales (para configuración inicial o dropdowns)
   */
  getAllReportsForDropdown: async () => {
    const response = await profileReportApi.fetchCustom("/dropdown");
    return response.data;
  },

  /**
   * 🔹 Activar o desactivar un reporte para un perfil
   * @param payload { profileId: number; reportId: number; enable: boolean }
   */
  toggleReportForProfile: async (payload: {
    profileId: number;
    reportId: number;
    enable: boolean;
  }) => {
    const response = await profileReportApi.addCustom("/toggle", payload);
    return response.data;
  },
};

export default ProfileReportService;
